<template>
    <div v-if="showModal" id="ordered_item_detail" class="ui middle aligned center aligned grid">
        <div class="ui column segments">
            <div id="header" class="ui left aligned segment">
                <h3 class="ui header">진행건 상세정보 - {{ item._id }}</h3>
            </div>
            <div id="body" class="ui segment">
                <div class="ui bound sticky">
                    <img class="ui medium image" :src="getProductImage(item.product)" @click="onPictureClick">
                </div>
                <!-- <div class="right ui rail">
                    <img class="ui medium image" :src="getProductImage(item.product)">
                </div> -->
                <table class="ui definition compact table">
                <tbody>
                    <tr>
                        <td class="collapsing">업체</td>
                        <td colspan="2">{{ getPartner(item._partner).name }}</td>
                    </tr>
                    <tr>
                        <td class="collapsing">운송장번호</td>
                        <td colspan="2">{{ item.trackingNumber }}</td>
                    </tr>
                    <tr>
                        <td class="collapsing">주문날짜</td>
                        <td colspan="2">
                            <div class="ui calendar" id="calendar_orderedAt">
                                <div class="ui input left icon">
                                    <i class="calendar icon"></i>
                                    <input type="text" v-model="item.orderedAtText" :disabled="item.isCanceled || isPartner || isCenter">
                                </div>
                            </div>
                        </td>
                        <!-- <td>
                            <div class="ui calendar" id="button_calendar">
                                <div class="ui button">변경</div>
                            </div>
                        </td>
                        <td>
                            {{ new Date(item.orderedAt).format("yyyy-MM-dd(KS) hh:mm") }}
                        </td> -->
                    </tr>
                    <tr>
                        <td class="collapsing">주문자</td>
                        <td colspan="2">{{ item.orderer }}</td>
                    </tr>
                    <tr>
                        <td class="collapsing">주문자 전화번호</td>
                        <td colspan="2">{{ item.ordererTel }}</td>
                    </tr>
                    <tr :class="item.receiver != oldItem.receiver ? 'yellow' : ''">
                        <td class="collapsing">수취인</td>
                        <td colspan="2">
                            <div class="ui fluid input">
                                <input type="text" v-model="item.receiver" @change="checkChange" :disabled="item.isCanceled || isPartner || isCenter">
                            </div>
                        </td>
                    </tr>
                    <tr :class="item.receiverTel != oldItem.receiverTel ? 'yellow' : ''">
                        <td class="collapsing">수취인 전화번호</td>
                        <td colspan="2">
                            <div class="ui fluid input">
                                <input type="text" v-model="item.receiverTel" @change="checkChange" :disabled="item.isCanceled || isPartner || isCenter">
                            </div>
                        </td>
                    </tr>
                    <tr :class="item.address != oldItem.address ? 'yellow' : ''">
                        <td class="collapsing">주소</td>
                        <td colspan="2">
                            <div class="ui fluid input">
                                <input type="text" v-model="item.address" @change="checkChange" :disabled="item.isCanceled || isPartner || isCenter">
                            </div>
                        </td>
                    </tr>
                    <tr :class="item.product != oldItem.product ? 'yellow' : ''">
                        <td class="collapsing">상품</td>
                        <td colspan="2">
                            <div id="ordered_product_dropdown" :class="(isCenter || isPartner || item.isCanceled) ? 'ui disabled fluid search selection dropdown' : 'ui fluid search selection dropdown'">
                                <input type="hidden" id="product_input">
                                <i class="dropdown icon"></i>
                                <div class="default text">상품 선택</div>
                                <div class="menu">
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr :class="item.count != oldItem.count ? 'yellow' : ''">
                        <td class="collapsing">수량</td>
                        <td colspan="2"> {{ item.count }} </td>
                    </tr>
                    <tr>
                        <td class="collapsing">고객요청사항</td>
                        <td colspan="2">{{ item.clientMemo }}</td>
                    </tr>
                    <tr :class="item._center != oldItem._center ? 'yellow' : ''">
                        <td class="collapsing">담당센터</td>
                        <td colspan="2">
                            <select class="ui simple dropdown" v-model="item._center" @change="checkChange" :disabled="item.isCanceled || isPartner || isCenter">
                                <option :value="c._id" v-for="c in getCenters()" :key="c._id">{{ c.name }}</option>
                            </select>
                        </td>
                    </tr>
                    <tr :class="item._worker != oldItem._worker ? 'yellow' : ''">
                        <td class="collapsing">배송기사</td>
                        <td>
                            <select class="ui simple dropdown" v-model="item._worker" @change="checkChange" :disabled="isPartner || item.isCanceled || item.type == constant.TYPE_PARCEL">
                                <option :value="w._id" v-for="w in getWorkers(item._center)" :key="w._id">{{ w.name }}</option>
                            </select>
                        </td>
                        <td>{{ getWorker(item._worker) ? getWorker(item._worker).phone : "" }}</td>
                        <td class="collapsing" v-if="isHeader">
                            <i class="file outline icon" @click="showWorkerList(item._center)"></i>
                        </td>
                    </tr>
                    <tr :class="item.type != oldItem.type ? 'yellow' : ''">
                        <td class="collapsing">타입</td>
                        <td colspan="2">
                            <select class="ui simple dropdown" v-model="item.type" @change="checkChange" :disabled="isPartner || item.isCanceled">
                                <option :value="constant.TYPE_DELIVERY">배송</option>
                                <option :value="constant.TYPE_INSTALL">설치</option>
                                <option :value="constant.TYPE_EXCHANGE">교환</option>
                                <option :value="constant.TYPE_RECALL">회수</option>
                                <option :value="constant.TYPE_PARCEL">택배</option>
                                <option :value="constant.TYPE_AS">A/S</option>
                            </select>
                        </td>
                    </tr>
                    <tr :class="item.partnerMemo != oldItem.partnerMemo ? 'yellow' : ''">
                        <td class="collapsing">메모(설치유형)</td>
                        <td colspan="2">
                            <div class="ui fluid input">
                                <input type="text" v-model="item.partnerMemo" @change="checkChange" :disabled="isPartner || isCenter || item.isCanceled">
                            </div>
                        </td>
                    </tr>
                    <tr :class="item.comment != oldItem.comment ? 'yellow' : ''">
                        <td class="collapsing">코멘트</td>
                        <td colspan="2">
                            <div class="ui fluid input">
                                <input type="text" v-model="item.comment" @change="checkChange">
                            </div>
                        </td>
                    </tr>
                    <tr :class="item.appointedAt != oldItem.appointedAt ? 'yellow' : ''">
                        <td class="collapsing">방문예정일</td>
                        <td colspan="2">
                            <div class="ui calendar" id="calendar_appointed">
                                <div class="ui input left icon">
                                    <i class="calendar icon"></i>
                                    <input type="text" v-model="item.appointedAtText" placeholder="미정" :disabled="isPartner || item.isCanceled">
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr :class="item.appointedAt != oldItem.appointedAt ? 'yellow' : ''">
                        <td class="collapsing">
                            <div class="ui checkbox">
                                <input type="checkbox" v-model="item.isCanceled" @change="checkChange">
                                <label>취소</label>
                            </div>
                        </td>
                        <td class="collapsing">
                            <select class="ui simple dropdown" v-model="item.cancelCount" :disabled="!item.isCanceled">
                                <option :value="undefined">수량</option>
                                <option :value="c" v-for="c in item.count" :key="c">{{ c }}</option>
                            </select>
                        </td>
                        <td>
                            <div class="ui fluid input">
                                <input type="text" v-model="item.cancelReason" placeholder="취소사유를 입력하세요" :disabled="!item.isCanceled">
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
            <!-- <div id="photo" class="ui segment">
                <img class="ui centered medium image" :src="getProductImage(item.product)">
            </div> -->
            </div>
            <div id="footer" class="ui right aligned segment">
                <div class="ui text menu">
                    <div class="right menu">
                        <div class="item" v-if="isHeader && isFinished">
                            <div class="ui label">주의: 완료 확정시 완료건으로 전환됩니다!</div>
                        </div>
                        <div class="item" v-if="isHeader && isFinished">
                            <div class="ui red button" @click="completeOrderedItem">완료 확정</div>
                        </div>
                        <div class="item" v-if="isHeader && !item.isCanceled && !oldItem.isCanceled && !isChanged && !isFinished">
                            <div class="ui orange button" @click="setFinished">완료</div>
                        </div>
                        <div class="item" v-if="isHeader && item.isCanceled && oldItem.isCanceled">
                            <div class="ui orange button" @click="confirmCancel">취소 확정</div>
                        </div>
                        <!-- <div class="item" v-if="!isFinished"> -->
                        <div class="item" :disabled="isFinished">
                            <div :class="isChanged ? 'ui blue button' : 'ui disabled button'" @click="save">변경</div>        
                        </div>
                        <div class="item">
                            <div class="ui button" @click="close">닫기</div>  
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data: function() {
        return { showModal: 0, oldItem: 0, item: 0, isChanged: 0, isFinished: 0, partnerProducts: 0, onChange: 0, }
    },
    created: function() {
        this.showModal = false;
        this.oldItem = this.item = this.isChanged = this.onChange = 0;
    },
    mounted: function() {
        window.addEventListener('keyup', (e) => { if (this.showModal && e.keyCode === 27) this.close(); });
        this.$event.set("orderedItemDetail_open", this.open);
    },
    beforeDestroyed: function() {
        this.$event.clear("orderedItemDetail_open");
    },
    methods: {
        open(_itemId, onChange)
        {
            $('.ui.sticky').sticky();

            this.isFinished = false;

            this.$event.call("openLoading");
            this.$api.getOrderedItem(_itemId, (resData) => {
                this.$event.call("closeLoading");
                if (resData.error) {
                    alert(resData.error.message);
                } else if (resData.item) {
                    if (!resData.item.isCanceled) resData.item.isCanceled = false;
                    this.showModal = true;
                    this.oldItem = resData.item;
                    this.item = JSON.parse(JSON.stringify(resData.item));
                    this.item.orderedAtText = this.item.orderedAt;
                    this.item.appointedAtText = this.item.appointedAt;
                    this.partnerProducts = this.findProducts(resData.item._partner);
                    this.onChange = onChange;
                    this.checkChange();
                    this.$nextTick(() => {
                        this.$ui.korCalendar("#calendar_orderedAt", (date, text) => {
                            this.item.orderedAt = date;
                            this.item.orderedAtText = text;
                            this.checkChange();
                        });
                        this.$ui.korCalendar("#calendar_appointed", (date, text) => {
                            this.item.appointedAt = date;
                            this.item.appointedAtText = text;
                            this.checkChange();
                        });
                        this.$ui.dropdown("#ordered_product_dropdown", (value) => {
                            this.item.product = value;
                            this.checkChange();
                        });

                        this.$ui.setDropdownValues("#ordered_product_dropdown", this.partnerProducts.map((p) => {
                            return { name: p.name, value: p.name };
                        }));
                        this.$ui.setDropdownSelected("#ordered_product_dropdown", this.item.product);
                    });
                }
            });
        },
        close() {
            this.showModal = false;
        },
        save() {
            if (this.item.isCanceled) {
                if (!Boolean(this.item.cancelCount)) { alert("취소수량을 선택하세요!"); return; }
                if (!Boolean(this.item.cancelReason)) { alert("취소사유를 입력하세요!"); return; }
            } else {
                this.item.cancelCount = undefined;
                this.item.cancelReason = undefined;
            }

            if (this.oldItem.address != this.item.address) {

                this.$event.call("openLoading");
                this.$address.search(this.item.address, (err, region1, region2, addressX, addressY) => {
                    this.$event.call("closeLoading");
                    if (err) {
                        alert(err);
                    } else {
                        this.item.region1 = region1;
                        this.item.region2 = region2;
                        this.item.addressX = addressX;
                        this.item.addressY = addressY;
                        this.modify();
                    }
                });
            } else {
                this.modify();
            }
        },
        modify() {
            this.$event.call("openLoading");
            this.$api.modifyOrderedItems(this.item._id, this.item, (resData) => {
                this.$event.call("closeLoading");
                if (resData.error) {
                    alert(resData.error.message);
                } else {
                    if (this.onChange) this.onChange();
                    this.close();
                }
            });
        },
        confirmCancel() {
            this.$event.call("openLoading");
            this.$api.confirmCancelItem(this.item._id, (resData) => {
                this.$event.call("closeLoading");
                if (resData.error) {
                    alert(resData.error.message);
                } else {
                    if (this.onChange) this.onChange();
                    this.close();
                }
            });
        },
        onCountChange() {
            if (this.item.count < 1) this.item.count = 1;
            this.checkChange();
        },
        checkChange() {
            this.isChanged = false;
            if (this.oldItem.orderedAt != this.item.orderedAt) this.isChanged = true;
            if (this.oldItem.type != this.item.type) this.isChanged = true;
            if (this.oldItem.product != this.item.product) this.isChanged = true;
            if (this.oldItem.address != this.item.address) this.isChanged = true;
            if (this.oldItem.count != this.item.count) this.isChanged = true;
            if (this.oldItem.receiver != this.item.receiver) this.isChanged = true;
            if (this.oldItem.receiverTel != this.item.receiverTel) this.isChanged = true;
            if (this.oldItem._center != this.item._center) this.isChanged = true;
            if (this.oldItem._worker != this.item._worker) this.isChanged = true;
            if (this.oldItem.partnerMemo != this.item.partnerMemo) this.isChanged = true;
            if (this.oldItem.reasonForCancel != this.item.reasonForCancel) this.isChanged = true;
            if (this.oldItem.appointedAt != this.item.appointedAt) this.isChanged = true;
            if (this.oldItem.comment != this.item.comment) this.isChanged = true;
            if (this.oldItem.isCanceled != this.item.isCanceled) this.isChanged = true;
        },
        setFinished()
        {
            this.isFinished = true;
        },
        completeOrderedItem()
        {
            if (this.isFinished)
            {
                this.$api.completeOrderedItem(this.item._id, (resData) =>
                {
                    this.$event.call("closeLoading");
                    if (resData.error) {
                        alert(resData.error.message);
                    } else {
                        if (this.onChange) this.onChange();
                        this.close();
                    }
                });
            }
        },
        findProducts(_partnerId) {
            const array = [];
            for (const product of this.products) {
                if (product._partner == _partnerId) {
                    array.push(product);
                }
            }
            return array;
        },
        getProductImage(productName) {
            for (const product of this.products) {
                if (product.name == productName) {
                    return product.imageUrl;
                }
            }
            return "https://fomantic-ui.com/images/wireframe/image.png";
        },
        getWorkers(_center)
        {
            const array = [];
            for (const worker of this.workers)
            {
                if (worker.position == "배송기사")
                {
                    if (!_center || worker._center == _center)
                    {
                        array.push(worker);
                    }
                }
            }
            return array;
        },
        getCenter(_centerId) {
            for (const center of this.centers) {
                if (center._id == _centerId) {
                    return center;
                }
            }
            return null;
        },
        getWorker(_workerId) {
            for (const worker of this.workers) {
                if (worker._id == _workerId) {
                    return worker;
                }
            }
            return null;
        },
        showWorkerList(_centerId)
        {
            const center = this.getCenter(_centerId);
            this.$event.call("openWorkerList", center, () =>
            {
                this.$event.call("openLoading");
                this.$api.getCenters((resData) => {
                    this.$event.call("closeLoading");
                    if (resData.error) {
                        alert(resData.error.message);
                    } else {
                        this.centers = resData.centers;
                        this.workers = resData.workers;
                    }
                });
            });
        },
        getPartner(_partnerId) {
            for (const partner of this.partners) {
                if (partner._id == _partnerId) {
                    return partner;
                }
            }
            return null;
        },
        getCenters()
        {
            const array = [];
            for (const center of this.centers)
            {
                if (!center.isTerminated) array.push(center);
            }
            return array;
        },
        onPictureClick()
        {
            this.$event.call("openPhotoByUrl", this.getProductImage(this.item.product));
        },
    },
    computed: {
        products: function() { return this.$store.getters.products; },
        isHeader: function() { return this.$store.getters.isHeader; },
        isCenter: function() { return this.$store.getters.isCenter; },
        isPartner: function() { return this.$store.getters.isPartner; },
        constant: function() { return this.$store.getters.constant; },
        partners: function() { return this.$store.getters.partners; },
        centers: {
            get: function() { return this.$store.getters.centers; },
            set: function(val) { this.$store.commit("setCenters", val); },
        },
        workers: {
            get: function() { return this.$store.getters.workers; },
            set: function(val) { return this.$store.commit("setWorkers", val); },
        },
        orderedItems: {
            get: function() { return this.$store.getters.orderedItems; },
            set: function(val) { return this.$store.commit("setOrderedItems", val); },
        }
    },
}
</script>

<style>

.ui.bound.sticky {
    margin-left: 70%;
    width: 30%;
}

#ordered_item_detail {
    position: fixed;
    left: 0;
    top: 0;
    margin: 0;
    z-index: 1;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgba(0,0,0,0.8);
}

#ordered_item_detail .ui.column.segments {
    max-width: 600px;
}

#ordered_item_detail #header {
    padding: 20px 30px;
}

#ordered_item_detail #body {
    padding: 0;
    font-size: 13px;
}

#ordered_item_detail #body .table {
    padding: 30px;
}

#ordered_item_detail #footer {
    padding: 20px 20px;
    background-color: #eee;
}

#ordered_item_detail #footer .ui.text.menu {
    margin: 0;
}

#ordered_item_detail .ui.form {
    padding: 30px;
}
</style>


// WEBPACK FOOTER //
// src/components/OrderedItemModal_Detail.vue